/**
 * Sprung zu einem Abschnitt der Seite.
 *
 * Normalerweise übernimmt das Lenis und scrollt weich. Wer in seinem System
 * "Bewegung reduzieren" eingeschaltet hat, bekommt kein Lenis - dann springt
 * der Browser selbst, ohne Weichzeichnung. Ohne diesen Ersatzweg täten die
 * Menüpunkte in diesem Fall gar nichts: Der Klick wird abgefangen, und
 * window.__lenis?.scrollTo() liefe ins Leere.
 */
export function scrolleZu(ziel, optionen = {}) {
  if (window.__lenis) {
    window.__lenis.scrollTo(ziel, optionen);
    return;
  }

  const sanft = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const verhalten = sanft ? "smooth" : "auto";

  if (ziel === 0 || ziel === "top") {
    window.scrollTo({ top: 0, behavior: verhalten });
    return;
  }
  if (typeof ziel === "number") {
    window.scrollTo({ top: ziel, behavior: verhalten });
    return;
  }
  const el = typeof ziel === "string" ? document.querySelector(ziel) : ziel;
  if (el) el.scrollIntoView({ behavior: verhalten, block: "start" });
}
